import React, { useState, useEffect } from 'react';
import { object } from 'prop-types';
import { get, head, upperCase, replace } from 'lodash';
import axios from 'axios';
import { useReset } from '../../../utils/misc';
import { Button, CompanyGroupsSelect, CustomLogo, FlexContainer, FormInput, If, IsMobileWrapper, Loading, Main, NotFound, RootContainer, Row, SpaceBetween, Text } from '../../common';
import OrderCard from './OrderCard';
import { loadReCaptcha, ReCaptcha } from 'react-recaptcha-v3';
import { publicRuntimeConfig } from '../../../config';

const { recaptchaToken } = publicRuntimeConfig.settings;
const { deliveryUrl } = publicRuntimeConfig;

const Search = ({ session }) => {
    const initialValues = {
        companyGroup: { label: 'Jumbo', value: 'JUMBO' },
        genericErrorMessage: 'La orden ingresada no es correcta o no existe.'
    };

    const [companyGroup, setCompanyGroup] = useState(get(initialValues, 'companyGroup', {}));
    const [orderId, setOrderId] = useState(null);
    const [id, setId] = useState(null);
    const [error, setError] = useState(null);
    const [response, setResponse] = useState(null);
    const [reseting, setReseting] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        loadReCaptcha(recaptchaToken);
    }, []);

    const searchOrder = () => {
        window.grecaptcha.ready(() => {
            window.grecaptcha.execute(recaptchaToken, { action: 'submit' }).then(async token => {
                setResponse(null);
                setLoading(true);
                setError(null);
                try {
                    const { data } = await axios.request({
                        method: 'get',
                        url: `${deliveryUrl}/deliveryInfo?flag=${companyGroup}&idOrder=${orderId}`,
                        headers: { 'recaptcha-token': token }
                    });
                    if (get(data, 'internalCode') !== 200) {
                        setError(initialValues.genericErrorMessage);
                        setLoading(false);
                        return;
                    }
                    setId(orderId);
                    setResponse(head(get(data, 'payload', [])));
                    setLoading(false);
                } catch (error) {
                    setLoading(false);
                    setError(initialValues.genericErrorMessage);
                }
            });
        });
    };

    const disableSearchButton = () => {
        if (orderId) return false;
        return true;
    };

    const reset = () => {
        setCompanyGroup(get(initialValues, 'companyGroup', {}));
        setOrderId(null);
        setId(null);
        setError(null);
        setResponse(null);
        useReset(setReseting);
    };

    return (
        <RootContainer>
            <Main withFooter background='F4F4F4'>
                <IsMobileWrapper>
                    {({ isMobile }) => {
                         const filterContainerStyles = !isMobile ? {
                            maxWidth: '95%',
                            margin: 'auto',
                            boxShadow: true,
                            padding: 16,
                            borderRadius: 4
                        } : {};

                        const orderCardProps = {
                            isMobile,
                            data: response,
                            id
                        };

                        return (
                            <>
                                <FlexContainer padding={18} direction='column' backgroundColor='#FFFFFF'>
                                    <Row justify='center' padding={!isMobile ? 25 : 0}>
                                        <FlexContainer width='100%' justify='center'>
                                            <CustomLogo style={{ width: isMobile ? window.innerWidth * 0.5 : '195px', marginBottom: '18px' }} />
                                        </FlexContainer>
                                        <Text text='Buscador de pedidos' strong size={24} />
                                    </Row>
                                    <If
                                        condition={reseting}
                                        then={<Loading loading />}
                                        else={
                                            <Row>
                                                <FlexContainer flex={1} direction={isMobile ? 'column' : 'row'} {...filterContainerStyles}>
                                                    <CompanyGroupsSelect
                                                        defaultValue={companyGroup}
                                                        onChange={value => setCompanyGroup(replace(upperCase(get(value, 'value', '')), ' ', ''))}
                                                    />
                                                    <SpaceBetween show={!isMobile} />
                                                    <FormInput label='ID pedido' placeholder='Ingresa ID del pedido' onChange={({ target }) => setOrderId(get(target, 'value'))} />
                                                    <SpaceBetween show={!isMobile} />
                                                    <ReCaptcha
                                                        sitekey={recaptchaToken}
                                                        action='submit'
                                                    />
                                                    <FlexContainer paddingVertical={8} width='100%' align='center'>
                                                        <Button text='Limpiar' link onClick={reset} disabled={disableSearchButton()} />
                                                        <Button text='Buscar' action='action_name' onClick={searchOrder} disabled={disableSearchButton()} />
                                                    </FlexContainer>
                                                </FlexContainer>
                                            </Row>
                                        }
                                    />
                                </FlexContainer>
                                <FlexContainer padding={18} direction='column' align='center'>
                                    <Loading loading={loading} />
                                    <If
                                        condition={response}
                                        then={<OrderCard {...orderCardProps} />}
                                    />
                                    <If
                                        condition={error}
                                        then={
                                            <NotFound
                                                firstTextLine={error}
                                                backgroundColor='#f4f4f4'
                                                iconColor='#c0c0c0'
                                                iconBackgroundColor='#f4f4f4'
                                            />
                                        }
                                    />
                                </FlexContainer>
                            </>
                        );
                    }}
                </IsMobileWrapper>
            </Main>
        </RootContainer>
    );
};

Search.propTypes = {
    session: object
};

Search.defaultProps = {
    session: {}
};

export default Search;
